import { TScaWalletFromApi } from '@/store/models/sca.model';

export const restrictionsGroupBaseUrl = {
  mcc: 'mccRestrictionGroups',
  mid: 'merchantIdRestrictionGroups',
  country: 'countryRestrictionGroups',
};

export const restrictionsGroupCardParam = {
  mcc: 'mccRestrictionGroupId',
  mid: 'merchantRestrictionGroupId',
  country: 'countryRestrictionGroupId',
};

export const ApiScaWalletToScaWallet = (scaWalletFromApi: TScaWalletFromApi) => ({
  scaWalletId: scaWalletFromApi.id,
  ...scaWalletFromApi,
});
